/*************************************************/
/* NEWS                                          */
/*************************************************/

export function articles(body, bodyLoadingClass, currentCulture) {
    let articlesContainer,
        lazyLoadButton,
        lazyLoadContainer,
        articlesListContainer,
        pageSize,
        totalSize,
        articlesNodeIds,
        tagsSortOrder,
        itemsToSkip = 0,
        filterButtons;

    const articlesSectionSelector = '.articles-overview',
        lazoLoadButtonSelector = '.articles-overview__load-more',
        lazyLoadButtonContainerSelector = '.articles-overview__cta',
        articlesItemsListContainerSelector = '.articles-overview__items',
        articlesControllerUrl = '/umbraco/surface/articles/getpagedarticles',
        articlesTagFilterButtonsSelector = '.articles-overview__tags-filter-button',
        articlesTagFilterButtonActiveClass = 'articles-overview__tags-filter-button--active'
        ;

    const loadArticles = function (skip, take, replace) {
        body.classList.add(bodyLoadingClass);

        const newsControllerArgs = new URLSearchParams({
            articlesNodeIds: articlesNodeIds,
            itemsToSkip: skip,
            pageSize: take,
            showTags: articlesContainer.dataset.showTags,
            tagsSortOrder: tagsSortOrder,
            cultureCode: currentCulture
        });

        //Get filter value
        const urlParams = new URLSearchParams(window.location.search);
        const tagsFilter = urlParams.get('tag');
        if (tagsFilter) {
            newsControllerArgs.append('tag', tagsFilter);

            filterButtons.forEach(filterButton => {
                if (filterButton.dataset.tag == tagsFilter) {
                    totalSize = filterButton.dataset.setSize;
                    filterButton.classList.add(articlesTagFilterButtonActiveClass);
                } else {
                    filterButton.classList.remove(articlesTagFilterButtonActiveClass);
                }
            })
        }
        const fetchUrl = articlesControllerUrl + '?' + newsControllerArgs;

        fetch(fetchUrl, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
        }).then(response => {
            return response.text();
        }).then(data => {
            if (data.length) {
                if (replace) {
                    articlesListContainer.innerHTML = data;
                    lazyLoadContainer.style.display = "block";
                    itemsToSkip = pageSize;
                } else {
                    articlesListContainer.insertAdjacentHTML('beforeend', data);
                    //Add page size to items to skip count
                    itemsToSkip += pageSize;
                    //If there are no more items to fetch, remove the button
                    if (itemsToSkip >= totalSize) {
                        lazyLoadContainer.style.display = "none";
                    }
                }

            } else {
                console.log('Reponse was empty');
            }
            body.classList.remove(bodyLoadingClass);
        }).catch(err => {
            console.log('An error occured fetching the item page');
            console.error(err);
            body.classList.remove(bodyLoadingClass);
        });
    };

    const init = function () {
        articlesContainer = document.querySelector(articlesSectionSelector);

        if (articlesContainer) {
            articlesListContainer = articlesContainer.querySelector(articlesItemsListContainerSelector);
            pageSize = parseInt(articlesContainer.dataset.articleslistPagesize);
            totalSize = parseInt(articlesContainer.dataset.articleslistTotalsize);
            articlesNodeIds = articlesContainer.dataset.articlesNodeIds;
            tagsSortOrder = articlesContainer.dataset.tagsSortOrder;

            lazyLoadButton = articlesContainer.querySelector(lazoLoadButtonSelector);
            if (lazyLoadButton != null) {
                lazyLoadContainer = lazyLoadButton.closest(lazyLoadButtonContainerSelector);

                lazyLoadButton.addEventListener('click', e => {
                    loadArticles(itemsToSkip, pageSize);

                });
            }

            filterButtons = articlesContainer.querySelectorAll(articlesTagFilterButtonsSelector);
            if (filterButtons) {
                filterButtons.forEach(button => {
                    button.addEventListener('click', e => {

                        filterButtons.forEach(filterButton => {
                            filterButton.classList.remove(articlesTagFilterButtonActiveClass);
                        });

                        const tag = button.dataset.tag;
                        totalSize = button.dataset.setSize;

                        var searchParams = new URLSearchParams(window.location.search);
                        console.log(searchParams.has('tag',tag));
                        if (searchParams.has('tag',tag)) {
                            searchParams.delete('tag');
                            button.blur();
                        } else {
                            button.classList.add(articlesTagFilterButtonActiveClass);
                            searchParams.set('tag', tag);
                        }
                        const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
                        window.history.replaceState({ path: updatedUrl }, '', updatedUrl);


                        loadArticles(0, pageSize, true);
                    });
                });
            }

            loadArticles(0, pageSize);
        }
    };

    init();
}
